/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type Dayjs } from '@/lib/dayjs';
import { type Locale } from '@/types/i18n';

/**
 * Note: this groups locales differently from its neighbour `formatStoreTime`,
 * which pairs en-US with es-MX for the 12-hour clock. Mexico writes times like
 * the US but dates day-first, so the split here is intentional.
 */
export function formatReopenDate(date: Dayjs, locale: Locale): string {
  if (locale === 'en-US') {
    return date.format('MM/DD/YYYY');
  }

  return date.format('DD/MM/YYYY');
}
